export default __webpack_public_path__ + "static/media/storeBlack.f0f7f090.png";